import * as _ from 'lodash';
import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {ToastMessagesService} from '../../../services/toast-messages.service';

interface SalePoints {
  id: number;
  customer_name: string;
  user_id?: number;
  name?: string;
}

interface User {
  id: number;
  name: string;
  sales_group_names?: any;
}

@Component({
  styleUrls: ['./selection-dialog.component.scss'],
  templateUrl: './selection-dialog.component.html'
})
export class SelectionDialogComponent implements OnInit {
  title: string;
  mode: number;
  users: User[];
  filter: string;
  categoryId: number;
  displayColumns = [];
  dataSource: any;
  selection: any;
  isLoading: boolean;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  localSelectedSalePoints: any;
  localSelectedUsers: any;
  searchUserValue: any;
  searchSalePointValue: any;
  originalDataSource: any;
  selectedUsers: any;
  selectedSalePoints: any;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<SelectionDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.mode = data.mode;
    this.users = data.users;
    this.categoryId = data.categoryId;
    this.isLoading = false;
    this.selectedUsers = data.selectedUsers ? data.selectedUsers : null;
    this.localSelectedUsers = this.selectedUsers ? [...data.selectedUsers] : [];
    this.selectedSalePoints = data.selectedSalePoints ? data.selectedSalePoints : null;
    this.localSelectedSalePoints = this.selectedSalePoints ? [...data.selectedSalePoints] : [];
    this.filter = data.filter ? data.filter : null;
    this.displayColumns = data.mode === 0 ? ['select', 'name'] : ['select', 'name', 'customer_name'];
    this.dataSource = data.mode === 0 ? new MatTableDataSource<User>(this.data.users) : new MatTableDataSource<SalePoints>();
    this.selection = data.mode === 0 ? new SelectionModel<User>(true, []) : new SelectionModel<SalePoints>(true, []);
  }

  public async ngOnInit(): Promise<any> {
    this.dataSource.sort = this.sort;
    if (this.mode === 0) {
      this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);

      for (const user of this.selectedUsers) {
        const dataS = this.dataSource.data as User[];
        const userS = dataS.find(s => s.id === user.id);
        if (userS) {
          this.selection.select(userS);
        }
      }
    }
    if (this.mode === 1) {
      await this.initSalePoints();
    }

    this.dataSource.sort = this.sort;
  }

  async initSalePoints() {
    const data = [];
    try {
      this.isLoading = true;

      for (const user of this.users) {
        let filter = this.filter + ' = ' + user.id;
        if (this.categoryId === 1) {
          filter += ' AND !(account_group_id<=>3000) AND !(account_group_id<=>3009)';
        } else if (this.categoryId === 2) {
          filter += ' AND (account_group_id=3000 OR account_group_id=3009)';
        }
        const result = await this.commonService.getListWithParameters(`sale_point/simple`, filter) as SalePoints[];
        for (const salePoint of result) {
          const model: SalePoints = {
            id: salePoint.id,
            customer_name: salePoint.customer_name,
            user_id: user.id,
            name: user.name
          };
          data.push(model);
        }
      }

      this.originalDataSource = JSON.stringify(data);
      this.dataSource = new MatTableDataSource<SalePoints>(data);
      for (const salePoint of this.selectedSalePoints) {
        const dataS = this.dataSource.data as SalePoints[];
        const salePointS = dataS.find(s => s.id === salePoint.id);
        if (salePointS) {
          this.selection.select(salePointS);
        }
      }
      this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  closeDialog(value?: any) {
    this.matDialogRef.close(value);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      const data = this.dataSource.data as User[];
      data.forEach((row) => this.selection.select(row));
    }
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;

    // @ts-ignore
    const numRows = this.dataSource.data.length;

    return numSelected === numRows;
  }

  isSelectionValid(): boolean {
    return this.mode === 0 ? false : this.selection.selected.length === 0;
  }

  confirmUsers() {
    // const forRemoval = this.selection.selected.filter(x => this.localData.selectedSalePoints.includes(x));
    const forRemoval = _.differenceBy(this.localSelectedSalePoints, this.selection.selected, 'id');
    const result = {
      selected: this.selection.selected,
      forRemoval
    };
    // this.closeDialog(this.selection.selected);
    this.closeDialog(result);
  }

  applyFilterUser() {
    const filterValue = this.searchUserValue.trim().toLowerCase();
    this.dataSource.data = [];
    this.isLoading = true;
    const data = JSON.parse(this.originalDataSource);
    if (filterValue) {
      const search = [];
      for (const salePoint of data) {
        const index = salePoint.name.trim().toLowerCase().indexOf(filterValue);
        if (index !== -1) {
          search.push(salePoint);
        }
      }
      this.dataSource = new MatTableDataSource<SalePoints>(search);
    } else {
      this.dataSource = new MatTableDataSource<SalePoints>(data);
    }
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);

    for (const salePoint of this.selection.selected) {
      const dataS = this.dataSource.data as SalePoints[];
      const sp = dataS.find(s => s.id === salePoint.id);
      if (sp) {
        this.selection.select(sp);
      }
    }
    this.isLoading = false;
  }

  applyFilterSalePoint() {
    const filterValue = this.searchSalePointValue.trim().toLowerCase();
    this.dataSource.data = [];
    this.isLoading = true;
    const data = JSON.parse(this.originalDataSource);
    if (filterValue) {
      const search = [];
      for (const salePoint of data) {
        const index = salePoint.customer_name.trim().toLowerCase().indexOf(filterValue);
        if (index !== -1) {
          search.push(salePoint);
        }
      }
      this.dataSource = new MatTableDataSource<SalePoints>(search);
    } else {
      this.dataSource = new MatTableDataSource<SalePoints>(data);
    }
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);

    this.isLoading = false;

    for (const salePoint of this.selection.selected) {
      const dataS = this.dataSource.data as SalePoints[];
      const sp = dataS.find(s => s.id === salePoint.id);
      if (sp) {
        this.selection.select(sp);
      }
    }
  }
}
